/**
 * Display formatting. All date maths lives in @svcdue/core — this module only
 * turns dates into the strings the UI shows.
 */

import { daysBetween, toIso } from '@svcdue/core';
import type { IsoDate } from '@svcdue/core';

/** Today, as the engine wants it. The one place the app reads the clock. */
export function today(): IsoDate {
  return toIso(new Date());
}

export function daysUntil(iso: IsoDate): number {
  return daysBetween(today(), iso);
}

function asDate(iso: IsoDate): Date {
  return new Date(iso + 'T00:00:00');
}

/** "Aug 8" */
export function fmtShort(iso: IsoDate): string {
  return asDate(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/**
 * "Aug 8, 2026" — the short date carrying its year.
 *
 * The public timeline forecasts service years out, and a visitor has no
 * signed-in context to infer the year from, so "Aug 8" is genuinely ambiguous
 * there in a way it is not on the members' dashboard.
 */
export function fmtShortYear(iso: IsoDate): string {
  return asDate(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** "Sat, Aug 8" */
export function fmtWithWeekday(iso: IsoDate): string {
  return asDate(iso).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

/** "August 8, 2026" */
export function fmtLong(iso: IsoDate): string {
  return asDate(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
